/** Imperative escape hatch for NodeCG messages whose payload doesn't fit the
 *  `cmd` envelope discriminated union (e.g. `project.select`). Most state
 *  changes should still go through @livcg/nodecg-react's sendCommand /
 *  useCmd, which is typed end-to-end. */
export function sendRaw(messageName: string, payload: unknown): Promise<unknown> {
  const nodecg = (window as { nodecg?: {
    sendMessage(
      name: string,
      data: unknown,
      cb?: (err: unknown, response?: unknown) => void,
    ): Promise<unknown>;
  } }).nodecg;
  if (!nodecg) return Promise.reject(new Error("nodecg-not-loaded"));
  return new Promise((resolve, reject) => {
    nodecg.sendMessage(messageName, payload, (err, response) => {
      if (err) reject(err);
      else resolve(response);
    });
  });
}

/** Fire-and-forget sendRaw: swallow errors (UI stays responsive; live state
 *  comes back through replicants). Use when no ack handling is needed. */
export function send(messageName: string, payload: unknown): void {
  void sendRaw(messageName, payload).catch(() => undefined);
}
